import $ from 'jquery';
import { Controller } from '@hotwired/stimulus';

export default class AdminTranslationsController extends Controller {
  timeouts: Record<string, NodeJS.Timeout> = {};

  handleInput(event: InputEvent): void {
    const input = event.currentTarget! as HTMLInputElement;
    const field = input.id;

    const searchTerm = input.value;
    if (this.timeouts[field]) {
      clearTimeout(this.timeouts[field]);
    }
    this.timeouts[field] = setTimeout(function () {
      let url = input.dataset.url!;
      if (searchTerm.length >= 1) {
        $('.js-translation').remove();
        $('.pagination').remove();
        url = url + '?' + field + '=' + searchTerm;
        $.get(url, function (data) {
          $('#js-translations').html(find(data, '#js-translations')[0]);
          $('.wrap > .container').append(find(data, '.pagination'));
        });
      } else {
        $.get(url, function (data) {
          $('#js-translations').html(find(data, '#js-translations')[0]);
          $('.wrap > .container').append(find(data, '.pagination'));
        });
      }
    }, 300);
  }
}

function find(html: string, selector: string): JQuery<HTMLElement> {
  return $('<div>').append($.parseHTML(html)).find(selector);
}
